import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/lib/theme";

/**
 * Compact theme toggle pill. Swap knob position between dark (moon) and light (sun).
 */
export default function ThemeToggle({ className = "" }) {
  const { theme, toggle } = useTheme();
  const isLight = theme === "light";
  return (
    <button
      onClick={toggle}
      className={`fl-theme-toggle ${className}`}
      aria-label={isLight ? "Switch to dark theme" : "Switch to light theme"}
      title={isLight ? "Switch to dark theme" : "Switch to light theme"}
      data-testid="theme-toggle"
    >
      <span className="knob">
        {isLight ? <Sun size={10} /> : <Moon size={10} />}
      </span>
    </button>
  );
}
